import AppFeature from './AppFeature';
import { appCardDataFetcher } from './AppFeature.data-fetcher';

export { appCardDataFetcher };

export default AppFeature;
